export const NOISE_CANCELLATION_SLOT_ELEMENT_ID =
    'debug-mode-noise-cancellation-slot';
export const LOG_UI_TRACKING_EVENTS_KEY = 'debug/logUiTrackingEvents';
export const LOG_LOGGER_KEY = 'debug/logLogger';
